import React from "react";
import * as api from '../../services/article'
import AdList from './ArticleList.js'
import { Link } from "react-router-dom";

export default function Articles() {
    const [data, setData] = React.useState({ list: [], isFetching: false });
    const [editing, setEditing] = React.useState(false);
    const [originalState, setOriginalState] = React.useState([]);

    function loadData() {
        api.fetchArticles()
            .then(data => {
                setData({ list: data, isFetching: false });
            })
            .catch(error => {
                setData({ list: [], isFetching: false });
            })
    }

    function editSorting() {
        setOriginalState(data.list.slice());
        setEditing(true);
    }

    function cancelSorting() {
        setEditing(false);
        console.log(originalState);
        setData({ list: originalState.slice(), isFetching: false });
    }
    
    function onSort(list) {
        setData({ list: list, isFetching: false });
    }

    function updateSorting() {
        setOriginalState([]);
        var sortedIds = data.list.map(i => {
            return i.id
        });
        api.updateSort(sortedIds)
            .then(data => {
                setEditing(false);
            })
            .catch(error => {
                alert(error);
            })
    }

    React.useEffect(() => {
        setData({ list: [], isFetching: true });
        loadData()
    }, []);

    return (
        <div>
            <div className="header">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-end">
                            <div className="col">
                                <h1 className="header-title">Articles</h1>
                            </div>
                            <div className="col-auto">
                                {
                                    editing ?
                                        <div>
                                            <button className="btn btn-sm btn-primary ml-3" onClick={updateSorting}><i className="fe fe-save mr-2"></i>Update</button>
                                            <button className="btn btn-sm btn-outline-secondary ml-3" onClick={cancelSorting}>Cancel</button>
                                        </div>
                                        :
                                        <div>
                                            <Link id="form-button" className="btn btn-sm btn-outline-primary" to="/articles/new"><i className="fe fe-plus mr-2"></i> Add new Article</Link>
                                            <button className="btn btn-sm btn-outline-primary ml-3" onClick={editSorting}><i className="fe fe-align-justify mr-2"></i>Edit sorting</button>
                                        </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                {
                    data.list.length === 0 ?
                        null
                        :
                        <AdList list={data.list} editSorting={editing} onSort={onSort}></AdList>
                }

            </div>
        </div>
    );
}
